import React, { useEffect, useState } from 'react';
import { Select, Checkbox } from 'antd';
import './styles.scss';

const { Option } = Select;

const MultiSelectWithCheckboxes = ({ options = [], onSelectionChange = () => { }, maxTagCount = 1, placeholder = '', styles = {}, selectAll = false, selectedValues, disabledView = false, allowClear = true, reset = null, dropdownStyle={}, disabled = false }) => {
    const [selectedItems, setSelectedItems] = useState([]);
    const [disabledItems, setDisabledItems] = useState([]);

    const handleChange = (value, selectedItems) => {
        try {
            if (value.includes('all')) {
                setSelectedItems(options.map(option => option.value));
            } else {
                setSelectedItems(value);
            }
            const selectedItemValues = selectedValues.map(item => item.value);
            const uncheckedOptions = value.includes('all') ? [] : selectedValues.filter(option => !value.includes(option.value));
            const checkedOptions = value.includes('all') ? options : options.filter(option => value.includes(option.value));
            // const checkedOptions = value.includes('all') ? options : options.filter(option => value.includes(option.value) && !selectedItemValues.includes(option.value));
            onSelectionChange(checkedOptions, uncheckedOptions);
        } catch (error) {
            console.log(error);
        }
    };

    const toggleDisabledEdit = (value) => {
        try {
            setDisabledItems(disabledItems.filter(item => item !== value));
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        try {
            if (disabledView)
                setDisabledItems(options.map(option => option.value));
        } catch (error) {
            console.log(error);
        }
    }, []);

    useEffect(() => {
        try {
            if (selectedValues.length > 0) {
                setSelectedItems(selectedValues.map(option => option.value));
            }
        } catch (error) {
            console.log(error);
        }
    }, [selectedValues]);

    useEffect(() => {
        if (reset != null) {
            handleChange([], []);
            setSelectedItems([]);
        }
    }, [reset]);

    return (
        <Select
            size='large'
            mode="multiple"
            style={{
                ...styles,
                padding: 0
            }}
            placeholder={placeholder}
            value={selectedItems}
            disabled={disabled}
            onChange={handleChange}
            optionLabelProp="label"
            optionFilterProp="label"
            maxTagCount={maxTagCount}
            maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
            className='primary'
            allowClear={allowClear}
            showSearch
            dropdownStyle={{ padding: 0, position: 'absolute', zIndex: 50, ...dropdownStyle }}
            getPopupContainer={trigger => trigger.parentNode}
        >
            {selectAll && options.length > 0 && <Option value="all">
                <Checkbox
                    checked={selectedItems.length == options.length}
                    onChange={(e) => {
                        if (!e.target.checked) {
                            setSelectedItems([]);
                            onSelectionChange([], []);
                            handleChange([], []);
                        }
                    }}
                >
                    <label style={{ fontFamily: "Poppins", fontSize: 14 }}>Select All</label>
                </Checkbox>
            </Option>}
            {options.map((option) => (
                <Option key={option.value}
                    value={option.value}
                    label={option.label}
                    disabled={disabledItems.includes(option.value)}
                >
                    <div className="d-flex align-items-center justify-content-between">
                        <Checkbox
                            checked={selectedItems.indexOf(option.value) > -1}
                        // disabled={disabledItems.includes(option.value)}
                        >
                            <label style={{ fontFamily: "Poppins", fontSize: 14 }} htmlFor="">{option.label}</label>
                        </Checkbox>
                        {
                            disabledItems.includes(option.value) &&
                            <a href="javascript:void(0);" onClick={() => toggleDisabledEdit(option.value)} className='text-primary' style={{ fontSize: '16px' }}>
                                <i className='mdi mdi-pencil' />
                            </a>
                        }
                    </div>
                </Option>
            ))}
        </Select>
    );
};

export default MultiSelectWithCheckboxes;